module.exports = __webpack_public_path__ + "img/RGB_EPS.jpg";